import React from 'react';

import Sanitized from '@boilerplate/components/Sanitized';

import { RenderProps } from './types';

export default function RichTextRenderer({ value }: RenderProps) {
  return value ? <Sanitized>{value}</Sanitized> : '';
}
